<script>
    

  import { defineComponent} from "vue";
      
      export default defineComponent({
        setup() {
      
      
          return {
        
          };
        },
        data () {
            return {
            
            }
        },
        props:{
          //是否显示弹框
          changsrole:{
            type:Boolean,
            default:false
          },
          //内容去
          title:{
            type:String,
            default:'',
          },
          contents:{
            type:String,
            default:'',
          },
          //盒子的宽度
          widthStr:{
            type:String,
            default:""
          }
        },
        async mounted() {
        
           
        },
       created(){
       
        },
        methods: {
          Suresrole(){
            this.$emit('closeed')
          }
        },
        watch: {
        //   changsrole:{
        //   deep:true,
         
        //   // handler(newVal,oldVal){
            
        //   //   // if(newVal){
        //   //   //   const times = setTimeout(()=>{
        //   //   //     clearTimeout(times);
        //   //   //     const expression = document.querySelector(".tips");
        //   //   //   expression.style.opacity = "0";
        //   //   //   this.$emit('Suresrole')
        //   //   //   },1500);
              
        //   //   // }
        //   // }
        //  }
        },
        computed: {
          
        },
      });
      </script>
      
      <template>
        <div class="hones">
          <div v-if="changsrole" @click="closeRo" class="greyCover">
        <div class="TipsBox">
        <p>{{title}}</p>
        <p>{{contents}}</p>
        <button @click="Suresrole">{{$t('RechargePage.determin')}}</button>
       </div>
      </div>
         
        </div>
      </template>
      <style lang="less" scoped>
        body,html{
          height: 100%;
        }
      *{
          margin: 0;
          padding: 0;
        }
      .hones{
        // width: 100%;
        // height: 100%;
        position: relative;
      
      }
      img{
        display: block;
      }
      // .tipss{
        
        .greyCover{
  position: fixed;
  top:0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0,0,0,.5);
  z-index: 3;
 }
 .TipsBox{
  position: fixed;
  width: 2.7rem;
  height: 1.36rem;
  background: #FFFFFF;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  z-index: 4;
  border-radius: 0.14rem;
  &>:nth-child(1){
    width: 2.38rem;
    height: 0.22rem;
    font-size: 0.17rem;
    font-family: PingFang SC;
    font-weight: 600;
    color: #000000;
    margin: 0 auto;
    padding-top: 0.16rem;
  }
  &>:nth-child(2){
    width: 2.6rem;
    height: 0.36rem;
    font-size: 0.13rem;
    font-weight: 400;
    color: #000000;
    font-family: PingFang SC;
    margin: 0 auto;
    text-align: center;
    margin-top: 0.14rem;
    line-height: 0.15rem;
  }
  &>:nth-child(3){
    width: 2.7rem;
    height: 0.44rem;
    display: block;
    position: absolute;
    bottom: 0;
    border-radius:0 0 0.14rem 0.14rem;
    font-size: 0.17rem;
    font-weight: 600;
    color: #007AFF;
    border: none;
    border-top: 1px solid #EDEDED;
    background: #FFFFFF;
    font-family: PingFang SC;
    // margin: 0 auto;
  }
 }
      </style>
      